// Styles
import styles from './SearchColumnGroup.module.css';

/**
 * SearchColumnGroup
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} SearchColumnGroup component
 */
function SearchColumnGroup({ children }) {
  return (
    <div className={styles.container}>
      {children}
    </div>
  );
}

/**
 * SearchColumnGroupList
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} SearchColumnGroupList component
 */
export function SearchColumnGroupList({ children }) {
  return <div className={styles.list}>{children}</div>;
}

export default SearchColumnGroup;
